import { LoadingPanto, LoadingPantoProps, Modal } from "@codat/orchard-ui";
import React from "react";

export const LoadingPantoModal = (props: LoadingPantoProps) => {
  return (
    <Modal
      onClose={() => {
        // Disable close
      }}
      data-testid="loading-panto-modal"
    >
      <LoadingPanto {...props} />
    </Modal>
  );
};
